/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

import { cloudConsoleUrl } from './config';

const defaultConsole = 'https://cloud.ibm.com';
const assistantLink = 'catalog/services/watson-assistant';

/**
 * Get the URL where a user may create a Watson Assistant instance, based on the console URL (if specified) and the
 * well-known URL for the Watson Assistant catalog. If no console URL is provided, the default one will be used.
 *
 * @param {string | undefined} console The URL for the IBM Cloud console the be used to create the instance.
 * @return {string} The full URL where a user may create a Watson Assistant instance.
 */
export const getCreateInstanceUrl = (console?: string): string => {
  if (!console) {
    console = cloudConsoleUrl || defaultConsole;
  }

  return urlJoin(console, assistantLink);
};
